function getRetailStoreInfoByZipCode (zipCode) {

	return fetch(`/api/storeavailability/storeinfo/ZipCode/${zipCode}/`).then((response) => response.json());

}

export default getRetailStoreInfoByZipCode;
